import { buildNeighborhoodOfficeSeo } from 'ux/Public/OfficeSeo/data/officeSeoNeighborhoodBuild';

export const sfHayesValleyOfficeSeo = buildNeighborhoodOfficeSeo({
  cityPathSegment: 'san-francisco',
  neighborhoodSlug: 'hayes-valley',
  neighborhoodDisplayName: 'Hayes Valley',
  metroDisplayName: 'San Francisco',
  totalCodiClientsInNeighborhood: 1,
  whereFromStreetsToLandmark:
    "from the buildings along Hayes St, Fell St, and Oak St to the clusters near Patricia's Green",
  whereTeamStreets: 'Hayes St, Fell St, Oak St, Laguna St',
  clientDescriptor: 'a small team tech startup near Hayes St',
  counts: {
    managedCleaningOffices: 1,
    managedPantryOffices: 1,
    managedInternetOffices: 1,
    managedFurnitureOffices: 1,
    managedOfficeAssistantOffices: 1,
    managedDeepCleaningOffices: 1,
    managedCarpetCleaningOffices: 1,
    managedWindowCleaningOffices: 1,
    managedGlassCleaningOffices: 1,
    managedWasteRecyclingOffices: 1,
    managedPantryInventoryOffices: 1,
    managedCoffeeServiceOffices: 1,
    managedWaterServiceOffices: 1,
    managedTeamLunchOffices: 1,
    managedBreakfastCateringOffices: 1,
    managedIndividualMealsOffices: 1,
    managedAdHocCateringOffices: 1,
    managedHappyHourOffices: 1,
    managedConferenceRoomAvOffices: 1,
    managedNetworkInstallationOffices: 1,
    managedNetworkManagementOffices: 1,
    managedCableManagementOffices: 1,
    managedRoomBookingOffices: 1,
    managedPrintingSetupOffices: 1,
    managedInteriorDesignOffices: 1,
    managedOfficeMuralsOffices: 1,
    managedOfficePaintingOffices: 1,
    managedGlassFrostingOffices: 1,
    managedOfficeSignageOffices: 1,
    managedCareRoomOffices: 1,
    managedFurnitureAssemblyOffices: 1,
    managedLayoutChangeOffices: 1,
    managedOfficePlantsOffices: 1,
    managedKeylessAccessOffices: 1,
    managedAlarmSystemsOffices: 1,
    managedSecurityCamerasOffices: 1,
    managedKeypadOffices: 1,
    managedLockboxOffices: 1,
    managedVisitorManagementOffices: 1,
    managedBusinessInsuranceOffices: 1,
    managedElectricalServicesOffices: 3,
    managedHvacOffices: 2,
    managedPlumbingOffices: 2,
    managedPestControlOffices: 2,
    managedOfficeMovingOffices: 3,
    managedMountingInstallationOffices: 4
  },
  quotes: {
    cleaning: 'We needed someone to just handle it \u2014 weekly cleaning, pantry, the whole thing.',
    pantryRestocking: 'The pantry was always running out. Since Codi took it over, it just stays stocked.',
    internet: 'Codi coordinated the vendor walkthrough and the whole install \u2014 we just showed up.',
    officeAssistant: "Codi's on-site person handles all the little things so the team can focus.",
    officeFurniture: 'The build-out was massive. Codi managed 8 major projects in 5 weeks.',
    deepCleaning: 'We do a deep clean every quarter. Codi schedules it and handles all the access logistics.',
    carpetCleaning: 'Our carpet was overdue for a proper clean. Codi found the vendor and handled the booking.',
    windowCleaning: 'Window cleaning is one of those things you forget until it\u2019s really obvious. Codi owns it.',
    glassConferenceRoom: 'Glass walls need constant upkeep. Codi put it on a schedule and it\u2019s never an issue.',
    wasteRecycling: 'SF recycling rules are no joke. Codi keeps us compliant without any effort on our end.',
    pantryInventory:
      'Pantry management was eating 30 minutes a week. Codi automated tracking and reordering completely.',
    coffeeService: 'Coffee is non-negotiable for our team. Codi handles the machine, the beans, and the maintenance.',
    waterService: 'Filtered water was an afterthought until Codi set it up. Now it\u2019s just part of the office.',
    teamLunch: 'We do a weekly creative lunch in Hayes Valley. Codi sources local caterers and handles the delivery.',
    breakfastCatering: 'Monday breakfast sets the tone for the week. Codi handles it so we can focus on the meeting.',
    individualMeals:
      'Individual lunch delivery for the whole team. Codi coordinates the vendor and keeps it consistent.',
    adHocCatering: 'Every board visit, Codi handles the catering. We just show up and it\u2019s already there.',
    happyHour:
      'We\u2019re a Hayes Valley office \u2014 good drinks are expected. Codi manages the order and the setup.',
    conferenceRoomAv: 'Creative agency needs great A/V in every room. Codi wired it all and keeps it working.',
    networkInstallation:
      'Codi handled our Hayes Valley network install \u2014 structured cabling, managed switch, the whole setup.',
    networkManagement: 'Codi keeps our network healthy so our designers and engineers never hit connectivity issues.',
    cableManagement: 'Codi organized all our studio cabling \u2014 clean runs, cable trays, labeled at every end.',
    roomBooking:
      'Creative studios need flexible meeting spaces. Codi deployed a booking system that works on every device.',
    printingSetup: 'Large format printing setup for our studio. Codi handled delivery coordination and driver config.',
    interiorDesign:
      'We wanted the Hayes Valley studio to feel intentional. Codi handled space planning and the full fit-out.',
    officeMurals:
      'Creative agency with a blank lobby wall. Codi connected us with a local artist and ran the whole installation.',
    officePainting:
      'Studio refresh every 18 months. Codi books the painters, schedules after-hours access, and the work gets done.',
    glassFrosting: 'We frosted the glass on the recording booth and one client room. Codi had it done in an afternoon.',
    officeSignage:
      'Our brand signage was DIY for too long. Codi designed and installed proper signage for the studio entrance.',
    careRoom:
      'New hire requested a private care room. Codi sourced furniture, added a curtain, and had it set up within the week.',
    furnitureAssembly:
      'Studio expansion meant 20 new workstations. Codi had a crew in and assembled everything in a single day.',
    layoutChange:
      'Reorganized the studio layout for a new workflow. Codi moved everything over a weekend and it was perfect Monday.',
    officePlants:
      'Hayes Valley office has great light. Codi brought in plants that fit the space and keeps them healthy monthly.',
    keylessAccess:
      'Creative studio in Hayes Valley \u2014 keyless access was the first security thing we set up. Codi handled everything.',
    alarmSystems:
      'Alarm system with after-hours monitoring. Codi selected the vendor, managed install, and handles all testing.',
    securityCameras:
      'Studio space with valuable equipment needed camera coverage. Codi installed and manages the system.',
    keypads: 'One main door keypad for the creative team. Codi manages codes and handles any maintenance needed.',
    lockboxes: 'Codi manages our lockbox for after-hours cleaning vendor access. Zero coordination needed from us.',
    visitorManagement:
      'Client-facing studio needs a professional check-in. Codi deployed a visitor system that handles arrival and compliance.',
    businessInsurance:
      'Lease required COI before we could take keys. Codi sourced our business insurance and manages renewals annually.',
    electricalServices:
      'Creative studio needed dedicated circuits for AV and server gear. Codi coordinated a licensed electrician and managed the building permit.',
    hvac: 'The HVAC in our Hayes Valley studio was noisy and inconsistent. Codi found an HVAC vendor, managed the service call, and it\u2019s been reliable since.',
    plumbing:
      'Kitchen faucet started leaking during a busy week. Codi had a plumber out quickly and we didn\u2019t have to think about it.',
    pestControl:
      'Moving into an older Hayes Valley building meant scheduling preventive pest control immediately. Codi handles the quarterly treatments.',
    officeMoving:
      'Moving the studio was a full day of coordination. Codi managed the mover, the building access, and the setup \u2014 we just worked.',
    mountingInstallation:
      'Mounted a large display and three whiteboards across the studio. Codi had it done in a few hours with clean cable management.'
  },
  officeAssistant: {},
  metroWideDemandPullquote: 'all'
});
